<template>
    <div>
        <div class="share_button_container">
            <button class="button is-info is-outlined share_button" @click="openModal"><i class="zmdi zmdi-share"></i></button>
        </div>

        <Modal @onConfirm="onConfirm" 
            @onClose="onClose" 
            :isOpen="isOpen" 
            :modalTitle="$t('components.shared.shareRefModal.title')"
            class="share_ref_modal" 
            :isLoading="isLoading">

            <AddContacts @contactListModified="handleContactList" ref="addContactComponent" :contactLabel="$t('components.shared.shareRefModal.contactLabel')">
                <template slot="headSlot">
                    <notifText class="share_ref_notice" v-html="$t('components.shared.shareRefModal.notice')" />
                </template>
            </AddContacts>
        </Modal>

        <transition name="notif-slide-up">
            <alert v-if="refShareNotif" context="success" @close="refShareNotif=false">{{ $t('components.shared.shareRefModal.successNotice') }}</alert>
        </transition>

    </div>
</template>

<script>
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'
import AddContacts from '@/components/shared/addContacts/addContacts'
import { setTimeout } from 'timers';

export default {
    name: 'shareRefModal',
    props: ['opened', 'currentRef'],
    components: {
        AddContacts
    },
    data(){
        return {
            isOpen: false,
            contactList: [],
            isLoading: false,
            refShareNotif: false
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        }
    },
    methods: {
        handleContactList(contactList){
            this.contactList = contactList
        },
        onConfirm(hasErrors){
            if(!hasErrors){
                this.isLoading = true
                const friendsRef = []
                this.contactList.forEach(contact => {
                    friendsRef.push({
                        friend_last_name: contact.last_name,
                        friend_first_name: contact.first_name,
                        friend_email: contact.email,
                        sight_ref_id: this.currentRef.id    
                    })
                })
                this.$store.dispatch('RefStore/createFriendRefs', friendsRef).then(() => {
                    setTimeout(() => {
                        this.$refs.addContactComponent.resetAllStates()
                        this.isLoading = false
                        this.isOpen = false
                        this.refShareNotif = true
                    }, 1000)
                })
            }
        },
        onClose(){
            this.isOpen = false
            this.$refs.addContactComponent.resetAllStates()
        },
        openModal(){
            if( userCanAccess('features', 'create_sight_ref') ){
                this.isOpen = true
            }else{
                this.$router.push('/unautorized'); 
            }
        }
    },
    watch: {
        'opened': {
            handler: function(newVal, oldVal){
                this.isOpen = newVal
            }
        }
    }
}
</script>

<style lang="scss" >
.share_ref_modal{
    .modal-card{
        width: 100%;
        max-width: 1024px;
        min-height: 600px;
    }
}
.share_ref_notice{
    max-width: 450px;
    margin-left: auto;
}
.share_button_container{
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>